/*
 * File: OrderFiltersDialog.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Dialog for selecting filters for orders list
 */
import React, { useState } from "react";
import { withStyles, Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import UIDialog from "components/ui/UIDialog";
import OrderFiltersForm from "./OrderFiltersForm";
import PropTypes from "prop-types";

const styles = theme => ({
  apply: {
    color: theme.palette.common.white,
    background: theme.palette.common.buttonGradient,
    width: "100%"
  }
});

const OrderFiltersDialog = ({
  classes,
  showFilterDialog,
  toggleFilterDialog
}) => {
  const [formRef, setFormRef] = useState(null);
  const saveChanges = () => {
    //This method will submit the filter form changes.
    if (formRef) formRef.submit();
    toggleFilterDialog();
  };

  const rightNav = () => (
    <CloseIcon
      id="close-orders-dialog"
      onClick={toggleFilterDialog}
      color="inherit"
    />
  );

  const filterForm = () => <OrderFiltersForm onRef={ref => setFormRef(ref)} />;

  const actions = () => (
    <Button
      id="button-save-new-order"
      color="primary"
      className={classes.apply}
      onClick={saveChanges}
    >
      Apply
    </Button>
  );

  return (
    <UIDialog
      open={showFilterDialog}
      title="Filters"
      rightNav={rightNav}
      content={filterForm}
      actions={actions}
    />
  );
};

OrderFiltersDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  showFilterDialog: PropTypes.bool,
  toggleFilterDialog: PropTypes.func.isRequired
};

export default withStyles(styles)(OrderFiltersDialog);
